<template>
  <div>
    <h6 class="text-lg mb-2 text-black font-semibold mt-4">
      {{ name }}
    </h6>
    <div class="flex flex-col">
      <ul
        role="list"
        class="text-sm md:text-md grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4"
      >
        <li
          v-for="(clinic, key) in clinics"
          :key="key"
          class="col-span-1 divide-y divide-gray-200 rounded-lg md:mb-10"
        >
          <div
            class="flex w-full items-center justify-between space-x-6 md:p-6"
          >
            <div class="flex-1 truncate">
              <div class="flex items-center space-x-3">
                <h3 class="truncate font-medium mb-2 mt-4 text-gray-900">
                  {{ clinic.name }}
                </h3>
              </div>

              <ul class="mt-1 truncate text-gray-500">
                <li>{{ clinic.street }}</li>
                <li>{{ clinic.city }}, {{ clinic.state }} {{ clinic.zip }}</li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
defineProps({
  clinics: {
    type: Object,
    default: () => ({}),
  },
  name: {
    type: String,
    default: "",
  },
});
</script>
